import React from "react";
import "../commoncss/Toast.css";

const Toast = ({ message, type = "info" }) => {
  return <div className={`toast toast_${type}`}>{message}</div>;
};

export default Toast;
